// utils/auth.js (새 파일 생성)
export const tokenUtils = {
    // 토큰 유효성 검사
    isTokenValid(token) {
        if (!token) return false;

        try {
            // JWT 토큰 디코딩 (단순 검사)
            const payload = JSON.parse(atob(token.split('.')[1]));
            const currentTime = Math.floor(Date.now() / 1000);

            // 만료 시간 확인
            return payload.exp > currentTime;
        } catch (e) {
            return false;
        }
    },

    // 관리자 토큰 가져오기
    getAdminToken() {
        const token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
        return this.isTokenValid(token) ? token : null;
    },

    // 사용자 토큰 가져오기 (🔥 sessionStorage만 사용 - 브라우저 닫으면 로그아웃)
    getUserToken() {
        const token = sessionStorage.getItem('auth_token');
        return this.isTokenValid(token) ? token : null;
    },

    // 토큰 제거
    clearTokens() {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('auth_token');
        sessionStorage.removeItem('adminToken');
        sessionStorage.removeItem('auth_token');
    }
};